var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignalTowerLine = function SvgSignalTowerLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.704 19.278A8.99 8.99 0 0 1 3 12a9 9 0 0 1 9-9 9 9 0 0 1 5.296 16.278l-.914-1.565a7.2 7.2 0 1 0-8.764 0zm1.831-3.136a5.4 5.4 0 1 1 6.93 0l-.927-1.59a3.6 3.6 0 1 0-5.076 0zM11.1 12.9h1.8V21h-1.8z"
  })));
};
export default SvgSignalTowerLine;